import { createContext } from "react";

// Context d'authentification, on y place le user et toutes ses informations
export const AuthContext = createContext(null);
